import { Component, OnInit } from '@angular/core';

import { BetPanel, EventListingService, Status, User, ConfigService } from 'baseline-lib';
import { PrintingService } from 'baseline-lib';
import { SessionService } from 'baseline-lib';
import { AppType, SharedService } from 'baseline-lib';
import { Notify } from 'baseline-lib';
import { TicketSummary } from 'baseline-lib';
import { MobileSharedService } from 'baseline-lib';
import { MyBetsSharedService } from 'baseline-lib';
import { VirtualBetSlip } from 'baseline-lib';
import { VirtualBetPanelService } from 'baseline-lib';
import { VirtualListingService } from 'baseline-lib';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { Global } from '../../../global/global';
import { ModalController, LoadingController, NavController, ToastController } from 'ionic-angular';
import { HomePage } from '../../home/home/home';
import { CustomToast } from '../../shared/services/custom-toast';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-virtual-betslip',
  templateUrl: 'virtual-betslip.html'
})
export class VirtualBetslipPage implements OnInit {
  _ticketSummary: TicketSummary
  _virtualBetSlip: VirtualBetSlip;
  _notify: Notify;
  currencySymbol : string;

  constructor(private _virtualBetpanelServices: VirtualBetPanelService,
    public mobileSharedService: MobileSharedService,
    private _virtualListingService: VirtualListingService,
    private _sharedService: SharedService,
    private _sessionService: SessionService,
    private _myBetsSharedService: MyBetsSharedService,
    private _printingService: PrintingService,
    private _eventListingService : EventListingService,
    public globalData : Global, public modalCtrl : ModalController,
    public loadingCtrl : LoadingController, public navCtrl : NavController,
    public toast : CustomToast, public translate : TranslateService, public _configService : ConfigService
  ) {
    this._virtualBetSlip = new VirtualBetSlip();
    this._ticketSummary = new TicketSummary();
    this._notify = new Notify();
    this._virtualBetSlip = this._virtualBetpanelServices.virtualBetSlip;
    this.currencySymbol = this._sessionService.getCurrenySymbol();
  }

  ngOnInit() {
  }

  public clearSlip() {
    this._virtualBetpanelServices.clearallBetPanels();
    this._virtualListingService.removePanel(-1, this._eventListingService.EventListObj);
    this._virtualBetpanelServices.betidCounter =0;
    this.manageView();
  }


  manageView() {
    this.mobileSharedService.betslipshow = false;
    this.mobileSharedService.listinghide = false;
  }

  backbut() {
    this.manageView();
  }

  removePanel(panel: BetPanel) {
    this._virtualBetpanelServices.removeBetPanel(panel);
    this._virtualListingService.removePanel(panel.pid , this._eventListingService.EventListObj);
    this.manageView();
  }

  placeBet() {

    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });
    loader.present();

    if (this.globalData.isLoggedIn && this.globalData.authUser) {
    
      this._sharedService.showLoader();
      this._virtualBetpanelServices.placeBet().
    
        subscribe(data => {
          loader.dismiss();
          this._sharedService.hideLoader();
          //update balance.
          if(this._sharedService._configService.getAppType() == AppType.user)
            this._sharedService.userBalanceUpdateGameType.next(data);
          else
            this._sharedService.userBalanceUpdate.next(data.bal);
          
            this.translate.get('Transaction Successful').subscribe(
              value => 
              {
                this.toast.showSuccess(value);
              });
            this.navCtrl.pop();

          // Notify MyBets.
          var authUser = this._sessionService.getAuthUser();
          switch (authUser.type) {
            case AppType.user:
              this._myBetsSharedService._placeMyBet.next(3);
              break;
            case AppType.retailer:
              this._ticketSummary.isBet = true;
              this._ticketSummary.isVirtual = true;
              this._ticketSummary.tsn = data.tktNo;
              this._ticketSummary.currency = data.cur;
              this._ticketSummary.totalTktCost = data.tc;
              this._ticketSummary.totalPot = this._virtualBetpanelServices.virtualBetSlip.totalWinnings;
              this._ticketSummary.saleDateTime = data.sdt;
              this._ticketSummary.retailerId = data.retid;
              this._ticketSummary.principleAgentId = data.pa;
              this._ticketSummary.superAgentId = data.sa;
              this._ticketSummary.betpanels = [];
              this._virtualBetpanelServices.virtualBetSlip.betpanels.forEach(element => {
                this._ticketSummary.betpanels.push(element);
              });

              this._sharedService.printingObj = this._ticketSummary;
              break;
          }
          this.clearSlip();
        },
          error => {
            loader.dismiss()
            this._sharedService.hideLoader();
            if (error.msg) {
              this.toast.showError(error.msg);
            }
            else {
              this._sharedService.errmsg = error.message;
              if (error.errorCode) 
              {
                if (error.errorCode == Status.unauthorised) 
                {
                  this.toast.showError("Please Login to continue!");
                  console.log('logout emitter');
                  localStorage.clear(); //logout;
                  this.globalData.selectedMenu = "home";
                  this.globalData.isLoggedIn = false;
                  this.globalData.authUser = new User();
                  this._virtualBetpanelServices.clearallBetPanels();
                  if(!this._configService.isplayerLogin())
                    this.navCtrl.setRoot(HomePage); 
                  this._sharedService.loginSubject.next(false);
                }
              }else{
                this.toast.showError(error.message);
              }
            }
          });
    }
    else {
      loader.dismiss();
      let profileModal = this.modalCtrl.create(LoginModalPage);
       profileModal.present(); 
    }
  }

  print() {
    this._printingService.printDetails('printingData')
  }

  onKey(event: any, index: number, panel: BetPanel) { // without type info   
    this._virtualBetpanelServices.calcTotalStakeAndPl();
  }

}



// WEBPACK FOOTER //
// ./src/app/virtual-sports/virtual-bet-slip/virtual-betslip.ts